import { render, staticRenderFns } from "./audioComponent.vue?vue&type=template&id=70e23b1e&scoped=true&"
import script from "./audioComponent.vue?vue&type=script&lang=js&"
export * from "./audioComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e23b1e",
  null
  
)

export default component.exports